module.exports = __webpack_public_path__ + "assets/img/img-fv-text-01.09eae3eb.svg";